import * as React from 'react';

import FileExcel32 from './FileExcel32';

export const fileExcel32 = () => <FileExcel32 />;

export default {
    title: 'Icon/Content/FileExcel32',
    component: FileExcel32,
    parameters: {
        notes: "`import FileExcel32 from 'box-ui-elements/es/icon/content/FileExcel32';`",
    },
};
